<template>
  <div id="intro">
    <div id='message'>
      <p>
Last October, I got an email from SFMOMA about a potential project. I was so excited, I hyperventilated for 5 minutes and messaged my sister and friends in all caps. I replied back immediately.
      </p>

      <p>
Last June, SFMOMA launched <a href='https://www.sfmoma.org/read/send-me-sfmoma/' target='_new'>Send Me SFMOMA</a>, a service where individuals could text a variety of requests - <em>“send me love”</em>, <em>“send me hope”</em>, <em>“send me smiles”</em> - and SFMOMA would respond with an artwork that best matched the request.  They received over 5 million texts from hundreds of thousands of individuals over the course of a year.
      </p>

      <p>
And they've asked me to do something fun with that data.
      </p>
<!--
      <p>
Their dataset was a dream; it was huge, it had interesting attributes, and it told stories. As soon as I started exploring their sample data, I knew what I wanted: I wanted to focus on individuals. I wanted to highlight their interactions with Send Me SFMOMA, when they texted, what they asked for, what they got back. Bonus points if I could surface how the artwork influenced their mood and what they asked for next. I wondered if I could experience what that person experienced, and feel what they felt.
      </p> -->

      <p>
I’ve chosen five individuals - whom I've named <span v-for='(journey, i) in journeys'>
  <span v-if='i === journeys.length - 1'> and </span>
  <router-link :to="{name: 'Art', params: {journey, index: i}}">{{ journey }}</router-link><span v-if='i < journeys.length - 1'>,</span>
</span> - and a week of their interactions to focus my visualization around.  Each tree represents a day in that individual’s life, and I love watching the flowers grow as they interact with <em>Send Me SFMOMA</em>.  I love coming across little snippets of their lives: when I find a tree blooming full with flowers, I wonder if something good happened that day.  When I watch a tree grow in the early hours of the morning, I wonder what’s keeping them up.  When I see a week filled with flowers, but suddenly a small tree with leaves of “mourning” and “black” - I wonder what might have happened.
      </p>

      <p>
In the months that I’ve been immersed with this dataset, I’ve grown to love it for its beauty and serendipity.  And with <em>Send Me Love</em>, I hope you'll also feel that joy - of watching a tree grow and flowers bloom, and of connecting with a perfect stranger over their texts.
      </p>

      <h3 class='red'>
        <router-link :to="{name: 'Art', params: {journey: 'love', index: 3}}">
          Explore a week of love</router-link> →
      </h3>
      <p>
        Shirley Wu<br />
        <em>Independent Creator of Data Visualizations</em>
      </p>
    </div>
    <Legend />
</div>
    </div>
  </div>
</template>

<script>
import Legend from './Legend';

export default {
  name: 'Intro',
  components: {Legend},
  props: ['headerHeight', 'footerHeight'],
  data() {
    return {
      journeys: ['love', 'happy', 'smile', 'cats', 'moon'],
    };
  },
}
</script>

<style scoped>
#intro {
  padding: 20px 30px;
}

#message {
  margin: auto;
  max-width: 900px;
  line-height: 1.6;
}

@media (min-width: 320px) and (max-width: 480px) {
  #intro {
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue